export const isBotName = (name: string): boolean => name.includes('#BOT#');
